import * as React from 'react';

const SvgCraneIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="128.000000pt"
      height="128.000000pt"
      viewBox="0 0 128.000000 128.000000"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <g transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)" fill="#bd7816" stroke="none">
        <path
          d="M77 1153 c-4 -3 -7 -53 -7 -109 0 -102 0 -103 28 -116 35 -17 43 -62
						12 -78 -25 -13 -47 -3 -64 31 -6 13 -18 24 -26 24 -25 0 -22 -41 5 -74 36 -42
						85 -43 126 -2 16 16 29 39 29 51 0 31 -27 78 -50 85 -16 5 -20 15 -20 56 0 27
						3 49 8 48 4 -1 122 -121 263 -268 l257 -266 -319 -3 -319 -2 0 -119 c0 -102 3
						-120 18 -134 10 -10 25 -17 33 -17 8 0 21 -16 27 -35 47 -128 232 -132 288 -5
						l18 40 233 0 233 0 14 -33 c17 -41 78 -93 118 -101 68 -14 145 31 175 102 12
						28 18 32 52 32 62 0 71 19 71 143 l0 106 -87 3 c-70 2 -88 6 -88 18 0 12 18
						16 88 18 l87 3 0 34 0 35 -205 0 c-192 0 -205 1 -215 19 -5 11 -10 81 -10 155
						l0 136 -35 0 c-61 0 -75 -25 -75 -136 l0 -96 -64 59 c-36 32 -146 136 -245
						231 l-180 172 -84 0 c-46 0 -87 -3 -90 -7z m201 -777 c73 -38 74 -147 2 -189
						-76 -45 -166 9 -163 98 2 81 87 129 161 91z m808 -20 c27 -27 34 -42 34 -74 0
						-82 -82 -134 -156 -98 -104 49 -67 206 48 206 32 0 47 -7 74 -34z"
        />
        <path
          d="M202 314 c-38 -26 -22 -74 24 -74 45 0 58 50 19 76 -18 12 -24 11
						-43 -2z"
        />
        <path
          d="M974 306 c-3 -8 -4 -25 -2 -38 2 -19 9 -23 38 -23 33 0 35 2 35 35 0
					 32 -3 35 -33 38 -21 2 -34 -2 -38 -12z"
        />
        <path
          d="M900 795 l0 -135 185 0 c118 0 185 4 185 10 0 10 -131 160 -198 227
						-31 31 -37 33 -102 33 l-70 0 0 -135z"
        />
      </g>
    </svg>
  );
};

export default SvgCraneIcon;
